// extracted by mini-css-extract-plugin
export default {"row":"Summary_row__eiVRG","col":"Summary_col__5lPJM","placeHolderShimmer":"Summary_placeHolderShimmer__3ou1h"};